import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
	GlobalRateCardId,
	RateCard,
	RateCardFamily,
	RateCardFuelLevies,
	RateCardFuelLeviesFamily,
	RateCardTypes,
	RateCardTypesFamily,
	RateCardRules,
	RateCardRulesFamily,
	RateCardModifiers,
	RateCardModifiersFamily,
	AllRateCardFuelLevyModifiers,
	AllRateCardFuelLevyModifiersFamily
} from '@state';

const useIsLinkedRateCard = () => {
	const rateCardId = useRecoilValue(GlobalRateCardId);
	return rateCardId !== 'default' ? rateCardId : null;
};

export const useRateCardState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? RateCardFamily(rateCardId) : RateCard);
};

export const useRateCardValue = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilValue(rateCardId ? RateCardFamily(rateCardId) : RateCard);
};

export const useSetRateCardState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useSetRecoilState(rateCardId ? RateCardFamily(rateCardId) : RateCard);
};

export const useRateCardFuelLeviesState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? RateCardFuelLeviesFamily(rateCardId) : RateCardFuelLevies);
};

export const useRateCardTypesState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? RateCardTypesFamily(rateCardId) : RateCardTypes);
};

export const useRateCardRulesState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? RateCardRulesFamily(rateCardId) : RateCardRules);
};

export const useRateCardModifiersState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? RateCardModifiersFamily(rateCardId) : RateCardModifiers);
};

export const useAllRateCardFuelLevyModifiersState = () => {
	const rateCardId = useIsLinkedRateCard();
	return useRecoilState(rateCardId ? AllRateCardFuelLevyModifiersFamily(rateCardId) : AllRateCardFuelLevyModifiers);
};
